import Keys from "../keys";
import axios from "axios";
import Cookies from "js-cookie";

const {API_URL, COOKIE_DOMAIN} = Keys;

const DoddnetApi = axios.create({
    baseURL: API_URL,
    timeout: 1200000,
    headers: {
        "Content-Type": "application/json",
        "api-key": process.env.NODE_ENV === 'development' ? process.env.REACT_APP_API_DEV_KEY:process.env.REACT_APP_API_KEY,
        "api-key-user": process.env.NODE_ENV === 'development' ?process.env.REACT_APP_API_DEV_KEY_USER:process.env.REACT_APP_API_KEY_USER
    }
});

DoddnetApi.interceptors.response.use(
    response => response,
    error => {
        if (error.response?.status === 401) {
            localStorage.removeItem('token');
            localStorage.removeItem('client');
            sessionStorage.removeItem('token');
            Cookies.remove('passthrough', { domain: COOKIE_DOMAIN, path: '/' });
            // _skipAuthRedirect allows callers to handle 401 locally without a hard navigation.
            // A hard window.location.href reload while an HTTP/2 connection to the API is active
            // can corrupt Edge's connection pool, causing ERR_NETWORK on the subsequent login request.
            if (!error.config?._skipAuthRedirect) {
                window.location.href = '/';
            }
        }
        return Promise.reject(error);
    }
);

export default DoddnetApi;